import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils.ts';

/** Badges de estado: verde ok · ámbar pendiente · rojo crítico · gris neutro (skill diseno-visual-mg). */
const badgeVariants = cva('inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap', {
  variants: {
    variant: {
      ok: 'border-transparent bg-mg-verde-claro text-mg-verde-oscuro',
      pendiente: 'border-transparent bg-amber-100 text-amber-800',
      critico: 'border-transparent bg-red-100 text-red-800',
      neutro: 'border-transparent bg-muted text-muted-foreground',
      info: 'border-transparent bg-blue-100 text-blue-800',
      fiscal: 'border-transparent bg-mg-rojo text-white',
      outline: 'text-foreground',
    },
  },
  defaultVariants: { variant: 'neutro' },
});

export function Badge({ className, variant, ...props }: ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
